/*
 * @Author: 任晓帅
 * @Contact: VX:ren18321147631
 * @Date: 2026-02-15 08:40:56
 * @Description: 不可进行二次销售
 */
import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const RefreshTokenKey = 'Admin-Refresh-Token'
const ExpiresInKey = 'Admin-Expires-In'

/**
 * 获取token
 */
export function getToken() {
  return Cookies.get(TokenKey)
}

/**
 * 设置token
 * @param {string} token - token
 * @param {Object} options - cookie选项
 */
export function setToken(token, options = {}) {
  return Cookies.set(TokenKey, token, options)
}

/**
 * 删除token
 */
export function removeToken() {
  return Cookies.remove(TokenKey)
}

/**
 * 获取刷新token
 */
export function getRefreshToken() {
  return Cookies.get(RefreshTokenKey)
}

/**
 * 设置刷新token
 * @param {string} token - 刷新token
 */
export function setRefreshToken(token) {
  return Cookies.set(RefreshTokenKey, token)
}

/**
 * 删除刷新token
 */
export function removeRefreshToken() {
  return Cookies.remove(RefreshTokenKey)
}

/**
 * 获取过期时间
 */
export function getExpiresIn() {
  return Cookies.get(ExpiresInKey)
}

/**
 * 设置过期时间
 * @param {string} time - 过期时间
 */
export function setExpiresIn(time) {
  return Cookies.set(ExpiresInKey, time)
}

/**
 * 删除过期时间
 */
export function removeExpiresIn() {
  return Cookies.remove(ExpiresInKey)
}

/**
 * 清除所有认证信息
 */
export function clearAuth() {
  removeToken()
  removeRefreshToken()
  removeExpiresIn()
}

/**
 * 判断是否已认证
 */
export function isAuthenticated() {
  return !!getToken()
}